export default __webpack_public_path__ + "static/Endurance_Small-27ecbcd58d0f13ad91b1ee588cdcca09.jpg";